/**
 * PromoStork's own contact address and social profiles (web plan "What I
 * need" #3, master §4 #12).
 *
 * A tiny pure module of its own (no `window`, no React, no imports) because
 * the site footer and the trust pages' liveness rule (@/seo/trustPages) read
 * them, and both are in the entry chunk: importing them from
 * @/seo/structuredData, which re-exports them for the Organization JSON-LD,
 * would pull every JSON-LD builder into the first download.
 */

/**
 * OWNER CONTENT: PromoStork's official social profile URLs (full `https://`
 * addresses: Instagram, Facebook Page, TikTok, YouTube, LinkedIn, X, WhatsApp
 * Channel). Empty until the owner confirms them; meanwhile the footer shows no
 * social icons and the JSON-LD lists none. Never add a profile the owner has
 * not confirmed. index.html's static copy must match (src/seo/indexHtml.test.ts).
 */
export const SITE_SOCIAL_PROFILES: readonly string[] = [];

/**
 * OWNER CONTENT: the domain contact email (e.g. `hello@promostork.com`).
 * Empty until it exists; meanwhile nothing is emitted, and the Contact page
 * (web plan W3.7) stays off even with its copy written.
 */
export const SITE_CONTACT_EMAIL = '';
